import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser, logout, mudarProcesso, mudarSocket } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';
// import { Tab, Tabs } from 'react-bootstrap';
import { Snackbar } from "@material-ui/core";


import moment from 'moment-timezone';
import ListaCandidatos from './ListaCandidatos';
import RedacoesCorrigidas from './RedacoesCorrigidas';
import TabPanel from './TabPanel';
import Dissertativas from './Dissertativas';
import DissertativasCorrigidas from './DissertativasCorrigidas';
import Loader from '../components/Loader';

class Sala extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: true,
            redirect: false,
            path: '/',
            salas: [],
            sala_select: {},
            tab: 0,
            tabCounts: {
                correctedEssays: 0,
                discursive: 0,
                correctedDiscursive: 0
            }
        }

        // this.videoRef=null;
    }


    componentDidMount() {
        let tab = new URLSearchParams(this.props.location.search).get('tab');
        if (tab !== undefined && tab !== null) this.setState({ tab: parseInt(tab) });
        else if (tab === null) this.setState({ tab: 0 });
        this.get_salas(this.props.match.params.id);

    }

    componentWillUnmount() {

    }

    async get_salas(id) {
        this.setState({ loading_screen: true });
        fetch(`${URL}api/corretor/get_salas/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);

                    // this.props.mudarLoadingHome(false);
                    setTimeout(() => {
                        this.get_salas(this.props.match.params.id);
                    }, 5000);
                }
                else {
                    this.props.mudarProcesso(resp.processo);

                    this.setState({ loading_screen: false, salas: resp.salas });
                    this.get_tab_counts(id);

                }




            } catch (err) {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.props.match.params.id);
                }, 5000);

            }

        })
            .catch((err) => {
                console.log(err);
                // this.props.mudarLoadingHome(false);
                setTimeout(() => {
                    this.get_salas(this.props.match.params.id);
                }, 5000);
            });
    }

    getPaginationTotal(resp, listKey) {
        if (resp.pagination != null) {
            if (resp.pagination.total != null) return resp.pagination.total;
            if (resp.pagination.to != null) return resp.pagination.to;
        }
        if (Array.isArray(resp[listKey])) return resp[listKey].length;
        return 0;
    }

    async fetchTabCount(url, listKey) {
        try {
            let response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Authorization': `Bearer ${this.props.token}`,
                }
            });
            let resp = await response.json();
            if (resp.message == "Unauthenticated.") {
                localStorage.removeItem('token');
                this.props.logout();
                return 0;
            }
            if (resp.errors != null || resp.error != null) return 0;
            return this.getPaginationTotal(resp, listKey);
        }
        catch (err) {
            console.log(err);
            return 0;
        }
    }

    async get_tab_counts(id) {
        let [correctedEssays, discursive, correctedDiscursive] = await Promise.all([
            this.fetchTabCount(`${URL}api/corretor/get_correcoes/${id}?page=1&search=`, 'correcoes'),
            this.fetchTabCount(`${URL}api/corretor/get_dissertativas/${id}?page=1&search=`, 'respostas'),
            this.fetchTabCount(`${URL}api/corretor/get_dissertativas_corrigidas/${id}?page=1&search=`, 'respostas')
        ]);
        this.setState({
            tabCounts: {
                correctedEssays,
                discursive,
                correctedDiscursive
            }
        });
    }


    render() {
        let t = this.props.t || {};
        let index = 0;
        let tabModules = [
            {
                label: t.pending_essays || 'Redações Pendentes',
                description: t.pending_essays_desc || 'Salas com redações aguardando correção',
                icon: 'mdi mdi-file-document',
                count: this.state.salas.length
            },
            {
                label: t.corrected_essays || 'Redações Corrigidas',
                description: t.corrected_essays_desc || 'Histórico das correções já finalizadas',
                icon: 'mdi mdi-file-check',
                count: this.state.tabCounts.correctedEssays
            },
            {
                label: t.discursive_questions || 'Questões Dissertativas',
                description: t.discursive_questions_desc || 'Respostas discursivas pendentes',
                icon: 'mdi mdi-format-list-checks',
                count: this.state.tabCounts.discursive
            },
            {
                label: t.corrected_discursive || 'Dissertativas Corrigidas',
                description: t.corrected_discursive_desc || 'Respostas discursivas finalizadas',
                icon: 'mdi mdi-checkbox-marked-circle-outline',
                count: this.state.tabCounts.correctedDiscursive
            }
        ];

        return (
            <div>

                {this.state.loading_screen == false && <div className="row correcao-module-page">
                    {this.state.redirect == true && <Redirect to={this.state.path} />}


                    {/* <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.props.faculdade.name}</h4>
                                <p style={{ fontSize: '1rem', color: 'black' }}>Nome do Fiscal: {this.props.user.name}</p>

                                <h4 style={{ color: 'black' }}>Comunicado Geral</h4>


                                <div className="d-flex" style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                                    <textarea id="msg_comunicado" placeholder="Escreva um comunicado Geral para enviar aos candidatos" className="form-control" style={{ resize: 'none', height: '100px' }} />
                                    <button className="btn btn-primary" id="enviar_comunicado">
                                        Enviar
                                        </button>
                                </div>

                            </div>
                        </div>
                    </div> */}
                    <div className="col-12">
                        <div className="card correcao-module-card">
                            <div className="card-body" >
                                <div className="row correcao-module-content" >

                                    {/* <div className="col-12" style={{ marginBottom: '1rem' }}>
                                       


                                    </div> */}
                                    <div className="col-12">
                                        <div className="correcao-room-head">
                                            <div>
                                                <span>{t.selective_process || 'Processo seletivo'}</span>
                                                <h4 style={{ color: 'black' }}>{this.props.processo.name}</h4>
                                            </div>
                                            <Link to='/' className="btn correcao-back-btn"><i className="mdi mdi-reply"></i> {t.back || 'Voltar'}</Link>
                                        </div>
                                        {/* <p className="m-b-20" style={{ color: 'black', whiteSpace: 'pre-line' }}>{this.props.processo.name}
                                                    </p> */}
                                        <div className="correcao-room-stats">
                                            <div>
                                                <small>{t.start_time || 'Hora de início'}</small>
                                                <strong>{moment(this.props.processo.inicio).format('DD/MM/YYYY')}</strong>
                                                <span>{moment(this.props.processo.inicio).format('HH:mm')}</span>
                                            </div>
                                            <div>
                                                <small>{t.end_time || 'Hora de encerramento'}</small>
                                                <strong>{moment(this.props.processo.fim).format('DD/MM/YYYY')}</strong>
                                                <span>{moment(this.props.processo.fim).format('HH:mm')}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12" style={{ width: '100%' }}>

                                        <div className="correcao-module-tabs">
                                            {tabModules.map((item, value) => (
                                                <button
                                                    key={item.label}
                                                    type="button"
                                                    className={this.state.tab == value ? 'active' : ''}
                                                    onClick={() => {
                                                        this.setState({ tab: value });
                                                        this.props.history.push({ search: `?tab=${value}` });
                                                    }}
                                                >
                                                    <i className={item.icon}></i>
                                                    <span>
                                                        <strong>{item.label}</strong>
                                                        <small>{item.description}</small>
                                                    </span>
                                                    <em>{item.count}</em>
                                                </button>
                                            ))}
                                        </div>
                                        <TabPanel value={this.state.tab} index={0}>
                                            <div className="correcao-list-panel">


                                                <div className="col-12">
                                                    <div className="correcao-card-list">
                                                        {this.state.salas.map((item, id) => (
                                                            <Link key={id} to={'/redacoes/' + item.sala.sala_corretor_id} className="correcao-list-card">
                                                                <div className="correcao-list-icon">
                                                                    <i className="mdi mdi-door-open"></i>
                                                                </div>
                                                                <div className="correcao-list-main">
                                                                    <span>{t.room || 'Sala'} {item.sala.numero}</span>
                                                                    <strong>{item.sala.redacao}</strong>
                                                                    <p>{(t.corrected_count_text || '{corrected} de {total} redações corrigidas').replace('{corrected}', item.correcoes).replace('{total}', item.textos)}</p>
                                                                </div>
                                                                <div className="correcao-list-action">
                                                                    <span>{t.open || 'Abrir'}</span>
                                                                    <i className="mdi mdi-arrow-right"></i>
                                                                </div>
                                                            </Link>
                                                        ))}
                                                    </div>
                                                    {this.state.salas.length == 0 && <div className="correcao-process-empty">
                                                        <i className="mdi mdi-clipboard-alert-outline"></i>
                                                        <p>{t.no_room_available || 'Nenhuma sala disponível para correção'}</p>
                                                    </div>}
                                                        </div>
                                            </div>
                                        </TabPanel>
                                        <TabPanel value={this.state.tab} index={1}>
                                            <RedacoesCorrigidas processo_id={this.props.processo.id} t={t} />


                                        </TabPanel>

                                        <TabPanel value={this.state.tab} index={2}>
                                            <Dissertativas processo_id={this.props.processo.id} t={t} />
                                        </TabPanel>

                                        <TabPanel value={this.state.tab} index={3}>
                                            <DissertativasCorrigidas processo_id={this.props.processo.id} t={t} />
                                        </TabPanel>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>}
                {this.state.loading_screen == true && <Loader />}
            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        socket: state.AppReducer.socket,
    }
);

export default connect(mapsStateToProps, { mudarUser, logout, mudarProcesso, mudarSocket })(Sala);
